module.exports = __webpack_public_path__ + "static/img/max_pictgrid25_980x836.17bd17a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/max_pictgrid25_980x836.jpg
// module id = +QjN
// module chunks = 0